import TextArea from 'components/Formik/TextArea';

const Story = ({ initialValues }) => {
	initialValues.story = '';
	return <TextArea label='Mission statement or program services' name='story' />;
};

export default Story;
